<template>
    <li class="card-item trip-card-item">
        <div v-if="getLocationImage !== null" class="image-wrapper">
            <ExternalImage :src="getLocationImage" />
        </div>
        <div v-else class="no-image-fallback" />
        <div class="card-data">
            <div class="top">
                <div class="bottom-overlay" />
                <h2 class="trip-title">{{ item.name }}</h2>
                <span v-for="(location, index) in item.locations" :key="index">
                    {{ location.geo.name }}
                    <div class="circle" />
                </span>
            </div>
            <div class="bottom">
                <span class="material-symbols-outlined icon">
                    calendar_month
                </span>
                <span>{{ getDateByMonth(item) }}</span>
            </div>
        </div>
        <router-link :to="`/trips/${item.id}`" class="fill-space" />
    </li>
</template>

<script>
import ExternalImage from "js/components/common/ExternalImage.vue";

export default {
    name: "TripCardItem",
    components: {
        ExternalImage,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        getLocationImage() {
            if (this.item.user_image_url) {
                return this.item.user_image_url;
            }
            if (!this.item.locations) {
                return null;
            }

            let found = this.item.locations.find((el) => el.image_url !== null);

            return found?.image_url ?? null;
        },
    },
    methods: {
        getDateByMonth(item) {
            let date = this.$formatDateByMonth(item.start_date);

            if (
                date !== this.$formatDateByMonth(item.end_date) &&
                item.end_date !== null
            ) {
                date += " - " + this.$formatDateByMonth(item.end_date);
            }

            return date;
        },
    },
};
</script>
